import { Form, Input } from "antd";
import React from "react";

const InputText = (props) => {
  return (
    <Form.Item
      required={props.required ?? true}
      label={
        <span
          style={{
            fontWeight: 500,
            lineHeight: "150%",
            color: "#212529",
          }}
        >
          {props.label}
        </span>
      }
      name={props.name}
      rules={
        props.rules ?? [
          {
            required: true,
            message: `Please input your ${props.message}!`,
          },
        ]
      }
      hidden={props.hidden ?? false} // Default false
    >
      <Input
        {...props}
        disabled={props.disabled}
        size="large"
        placeholder={props.type === "non user" ? `${props.placeholder}` : `Input your ${props.placeholder}`}
      />
    </Form.Item>
  );
};

export default InputText;
